<template>
  <section>
    <!--工具条-->
    <div>
      <el-col :span="2">
        <el-input
          v-model="filters.matName"
          placeholder="物资名称"
          @change="getData"
        ></el-input>
      </el-col>
      <el-col :span="2">
        <el-input
          v-model="filters.stationLineName"
          placeholder="生产线"
          @change="getData"
        ></el-input>
      </el-col>
      <el-col :span="10">
        <el-date-picker
          type="datetime"
          placeholder="开始日期"
          v-model="filters.startTime"
          value-format="yyyy-MM-dd HH:mm:ss"
        ></el-date-picker>
        <el-date-picker
          type="datetime"
          placeholder="结束日期"
          v-model="filters.endTime"
          value-format="yyyy-MM-dd HH:mm:ss"
        ></el-date-picker>
      </el-col>
      <el-col :span="6">
        <el-button type="primary" @click="getData">查询</el-button>
        <el-button type="primary" @click="handlePrints('print')">
          打印
        </el-button>
        <el-button type="primary" @click="downData">
          导出
        </el-button>
      </el-col>
    </div>
    <!--列表-->
    <el-table
      :data="dataList"
      highlight-current-row
      v-loading="listLoading"
      style="width: 100%"
      height="600"
      id="print"
      border
    >
      <el-table-column
        prop="MatName"
        label="物资名称"
      ></el-table-column>
      <el-table-column
        prop="ActualQuantity"
        label="实际耗料"
      ></el-table-column>
    </el-table>
  </section>
</template>

<script>
//引入dataList.js的所有export的对象,并起别名为api,通过api.***访问成员
import * as api from "../../api/command";
import { BaseApiUrl } from "../../api/api";
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import Axios from "axios";
import printJS from "print-js";
export default {
  components: { Toolbar },
  data() {
    return {
      currentRow: null,
      filters: {
        matName: "",
        stationLineName: "",
        startTime: "",
        endTime: "",
      },
      dataList: [],
      listLoading: false,
    };
  },
  computed: {},
  methods: {
    //工具条绑定事件方法
    callFunction(item) {
      this.filters = {
        name: item.search,
      };
      this[item.Func].apply(this, item);
    },
    //获取数据
    getData() {
      let para = this.filters;
      this.listLoading = true;
      api.GetManufactureAmount(para).then((res) => {
        this.dataList = res.data.response;
        this.listLoading = false;
      });
    },
    //导出数据
    downData() {
      let para = this.filters;
      var sheetName = "耗料合计信息";
      api.DownManufactureAmount(para, sheetName).then((res) => {});
    },
    /** 打印按钮操作 */
    handlePrints(id) {
      const html = document.querySelector("#" + id).innerHTML;
      // 新建一个 DOM
      const div = document.createElement("div");
      const printDOMID = "printDOMElement";
      div.id = printDOMID;
      div.innerHTML = html;

      // 提取第一个表格的内容 即表头
      const ths = div.querySelectorAll(".el-table__header-wrapper th");
      const ThsTextArry = [];
      for (let i = 0, len = ths.length; i < len; i++) {
        if (ths[i].innerText !== "") ThsTextArry.push(ths[i].innerText);
      }

      // 删除多余的表头
      div.querySelector(".hidden-columns").remove();
      // 第一个表格的内容提取出来后已经没用了 删掉
      div.querySelector(".el-table__header-wrapper").remove();

      // 将第一个表格的内容插入到第二个表格
      let newHTML = "<tr>";
      for (let i = 0, len = ThsTextArry.length; i < len; i++) {
        newHTML +=
          '<td style="text-align: center; font-weight: bold">' +
          ThsTextArry[i] +
          "</td>";
      }

      newHTML += "</tr>";
      div
        .querySelector(".el-table__body-wrapper table")
        .insertAdjacentHTML("afterbegin", newHTML);
      // 将新的 DIV 添加到页面 打印后再删掉
      document.querySelector("body").appendChild(div);
      printJS({
        printable: printDOMID,
        type: "html",
        scanStyles: false,
        style:
          "table {  width: 100%; border-collapse: collapse; border-spacing: 0; } table th{ line-height: 20px; padding: 9px 15px; border: 1px solid #ccc; text-align: left; font-size: 12px; color: #666;text-align: right;} table td{line-height: 20px; padding: 9px 15px; border: 1px solid #ccc; text-align: left; font-size: 12px; color: #666;text-align: left;}", // 表格样式
      });

      div.remove();
    },
  },
  mounted() {
    this.getData();
  },
};
</script>

<style lang="less" scoped>
.input-select {
  width: 300px;
}
</style>
